// src/data/calculatorData.js

export const vehicleData = [
  {
    vehicle: 'Tata Ace',
    category: 'SCV',
    dimensions: { length: 7, width: 4.8, height: 4.8 },
    extra_margin: 1.5,
    tarpaulin: { length: 18.1, width: 15.9 },
  },
  {
    vehicle: 'Mahindra Jeeto',
    category: 'SCV',
    dimensions: { length: 6, width: 4.5, height: 4.5 },
    extra_margin: 1.5,
    tarpaulin: { length: 16.5, width: 15 },
  },
  {
    vehicle: 'Ashok Leyland Dost',
    category: 'SCV',
    dimensions: { length: 7, width: 4.8, height: 4.8 },
    extra_margin: 1.5,
    tarpaulin: { length: 18.1, width: 15.9 },
  },
  {
    vehicle: 'Bolero Pickup',
    category: 'LCV',
    dimensions: { length: 8, width: 5, height: 4.8 },
    extra_margin: 1.5,
    tarpaulin: { length: 19.1, width: 16.1 },
  },
  {
    vehicle: 'Tata Intra V30',
    category: 'LCV',
    dimensions: { length: 8.5, width: 5.5, height: 5 },
    extra_margin: 1.5,
    tarpaulin: { length: 20, width: 17 },
  },
  {
    vehicle: 'Ashok Leyland Bada Dost',
    category: 'LCV',
    dimensions: { length: 9.5, width: 5.5, height: 5 },
    extra_margin: 1.5,
    tarpaulin: { length: 21, width: 17 },
  },
  {
    vehicle: 'Tata 407',
    category: 'LCV',
    dimensions: { length: 9, width: 5.5, height: 5 },
    extra_margin: 1.5,
    tarpaulin: { length: 20.5, width: 17 },
  },
  {
    vehicle: '10 ft Truck',
    category: 'LCV',
    dimensions: { length: 10, width: 6, height: 6 },
    extra_margin: 1.5,
    tarpaulin: { length: 23.5, width: 19.5 },
  },
  {
    vehicle: '12 ft Truck',
    category: 'LCV',
    dimensions: { length: 12, width: 6, height: 6.5 },
    extra_margin: 1.5,
    tarpaulin: { length: 26.5, width: 20.5 },
  },
  {
    vehicle: '14 ft Truck',
    category: 'MCV',
    dimensions: { length: 14, width: 6, height: 6.5 },
    extra_margin: 1.5,
    tarpaulin: { length: 28.5, width: 20.5 },
  },
  {
    vehicle: '17 ft Truck',
    category: 'MCV',
    dimensions: { length: 17, width: 6.5, height: 7 },
    extra_margin: 1.5,
    tarpaulin: { length: 32.5, width: 22 },
  },
  {
    vehicle: '19 ft Truck',
    category: 'MCV',
    dimensions: { length: 19, width: 6.5, height: 7 },
    extra_margin: 1.5,
    tarpaulin: { length: 34.5, width: 22 },
  },
  {
    vehicle: '20 ft Truck',
    category: 'HCV',
    dimensions: { length: 20, width: 7, height: 7 },
    extra_margin: 1.5,
    tarpaulin: { length: 35.5, width: 22.5 },
  },
  {
    vehicle: '22 ft Truck',
    category: 'HCV',
    dimensions: { length: 22, width: 7.5, height: 7 },
    extra_margin: 1.5,
    tarpaulin: { length: 37.5, width: 23 },
  },
  {
    vehicle: '24 ft Truck',
    category: 'HCV',
    dimensions: { length: 24, width: 7.5, height: 7 },
    extra_margin: 1.5,
    tarpaulin: { length: 39.5, width: 23 },
  },
  {
    vehicle: '27 ft Truck',
    category: 'MAV',
    dimensions: { length: 27, width: 7.5, height: 7 },
    extra_margin: 1.5,
    tarpaulin: { length: 42.5, width: 23 },
  },
  {
    vehicle: '28 ft Truck',
    category: 'MAV',
    dimensions: { length: 28, width: 8, height: 8 },
    extra_margin: 1.5,
    tarpaulin: { length: 45.5, width: 25.5 },
  },
  {
    vehicle: '32 ft Container',
    category: 'MAV',
    dimensions: { length: 32, width: 8, height: 8 },
    extra_margin: 1.5,
    tarpaulin: { length: 49.5, width: 25.5 },
  },
  {
    vehicle: '40 ft Trailer',
    category: 'Trailer',
    dimensions: { length: 40, width: 8, height: 9 },
    extra_margin: 1.5,
    tarpaulin: { length: 59.5, width: 27.5 },
  },
]

export const warehouseData = [
  {
    warehouse: 'Small Godown',
    category: 'Small',
    dimensions: { length: 30, width: 20, height: 10 },
    extra_margin: 2,
    tarpaulin: { length: 52, width: 42 },
  },
  {
    warehouse: 'Retail Storage Unit',
    category: 'Small',
    dimensions: { length: 50, width: 30, height: 12 },
    extra_margin: 2,
    tarpaulin: { length: 76, width: 56 },
  },
  {
    warehouse: 'Medium Warehouse',
    category: 'Medium',
    dimensions: { length: 100, width: 50, height: 15 },
    extra_margin: 3,
    tarpaulin: { length: 133, width: 83 },
  },
  {
    warehouse: 'FMCG Distribution Warehouse',
    category: 'Medium',
    dimensions: { length: 150, width: 80, height: 18 },
    extra_margin: 3,
    tarpaulin: { length: 189, width: 119 },
  },
  {
    warehouse: 'Large Warehouse',
    category: 'Large',
    dimensions: { length: 200, width: 100, height: 20 },
    extra_margin: 3,
    tarpaulin: { length: 243, width: 143 },
  },
  {
    warehouse: 'Logistics Hub',
    category: 'Large',
    dimensions: { length: 300, width: 150, height: 22 },
    extra_margin: 4,
    tarpaulin: { length: 348, width: 198 },
  },
  {
    warehouse: 'Industrial Storage Shed',
    category: 'Industrial',
    dimensions: { length: 400, width: 200, height: 25 },
    extra_margin: 4,
    tarpaulin: { length: 454, width: 254 },
  },
  {
    warehouse: 'Mega E-commerce Warehouse',
    category: 'Industrial',
    dimensions: { length: 600, width: 300, height: 30 },
    extra_margin: 4,
    tarpaulin: { length: 664, width: 364 },
  },
]

export const vehicleCategories = [
  { key: 'SCV', label: 'SCV – Small Commercial Vehicles', icon: 'bi-truck' },
  { key: 'LCV', label: 'LCV – Light Commercial Vehicles', icon: 'bi-truck' },
  { key: 'MCV', label: 'MCV – Medium Commercial Vehicles', icon: 'bi-truck-front' },
  { key: 'HCV', label: 'HCV – Heavy Commercial Vehicles', icon: 'bi-truck-front-fill' },
  { key: 'MAV', label: 'MAV – Multi-Axle Vehicles', icon: 'bi-truck-flatbed' },
  { key: 'Trailer', label: 'Trailer – Container / Flatbed', icon: 'bi-box-seam' },
]

export const warehouseCategories = [
  { key: 'Small', label: 'Small Storage', icon: 'bi-building' },
  { key: 'Medium', label: 'Medium Warehouse', icon: 'bi-buildings' },
  { key: 'Large', label: 'Large Warehouse / Hub', icon: 'bi-buildings-fill' },
  { key: 'Industrial', label: 'Industrial / Mega Facility', icon: 'bi-grid-3x3-gap-fill' },
]

/**
 * Round a value UP to the nearest multiple of 3
 * e.g. 28 → 30, 30 → 30, 31 → 33
 */
export function roundUpTo3(value) {
  return Math.ceil(value / 3) * 3
}
